import { FEATURE_NAME, useGetFeatures } from '../api';

export const useFeature = () => {
  const { data = [], isLoading } = useGetFeatures();

  const check = (featureName: FEATURE_NAME) =>
    !!data.find(featureData => featureData.feature === featureName)?.enabled;

  return {
    isLoading,
    transactions: check(FEATURE_NAME.TRANSACTIONS),
    api: check(FEATURE_NAME.API),
    mszafir: check(FEATURE_NAME.MSZAFIR),
    signius: check(FEATURE_NAME.SIGNIUS),
    externalSignature: check(FEATURE_NAME.EXTERNAL_SIGNATURE),
    zealidSignature: check(FEATURE_NAME.ZEALID_SIGNATURE),
    signaturePositionCustomization: check(
      FEATURE_NAME.SIGNATURE_POSITION_CUSTOMIZATION,
    ),
    emailCustomization: check(FEATURE_NAME.EMAIL_CUSTOMIZATION),
    documentBranding: check(FEATURE_NAME.DOCUMENT_BRANDING),
    queueGroups: check(FEATURE_NAME.QUEUE_GROUPS),
    identityConfirmationPwpw: check(FEATURE_NAME.IDENTITY_CONFIRMATION_PWPW),
    webhooks: check(FEATURE_NAME.WEBHOOKS),
    templateCreatorV2: check(FEATURE_NAME.TEMPLATE_CREATOR_V2),
    pdfRendererV2: check(FEATURE_NAME.PDF_RENDERER_V2),
    qrCode: check(FEATURE_NAME.QR_CODE),
    contactsV2: check(FEATURE_NAME.CONTACTS_V2),
    documentsV2: check(FEATURE_NAME.DOCUMENTS_V2),
    publicTemplates: check(FEATURE_NAME.PUBLIC_TEMPLATES),
    dataSources: check(FEATURE_NAME.DATA_SOURCES),
    autoReminders: check(FEATURE_NAME.AUTO_REMINDERS),
  };
};
